import React from 'react';
import NextLink from 'next/dist/client/link';

import { ItemLink, LetterBlock, Text } from './letter.styles';
import { iLetter } from './letter.types';

interface LetterProps {
  letter: iLetter;
  baseUrl: string;
}

export const Letter = ({ letter: { initial, data }, baseUrl }: LetterProps) => (
  <LetterBlock key={initial}>
    <Text>{initial}</Text>
    {data.map(({ slug, name }, idx) => (
      <ItemLink
        key={idx}
        onClick={() => {
          window.history.pushState({}, '', `/${baseUrl}/${slug}`);
          window.location.href = `/${baseUrl}/${slug}`;
        }}
        href={`/${baseUrl}/${slug}`}
      >
        {name}
      </ItemLink>
    ))}
  </LetterBlock>
);
